import { render, staticRenderFns } from "./RecapInscriptionUm6pComponent.vue?vue&type=template&id=631b1255&scoped=true"
import script from "./RecapInscriptionUm6pComponent.vue?vue&type=script&lang=js"
export * from "./RecapInscriptionUm6pComponent.vue?vue&type=script&lang=js"
import style0 from "./RecapInscriptionUm6pComponent.vue?vue&type=style&index=0&id=631b1255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b1255",
  null
  
)

export default component.exports